import styled from 'styled-components'
import { Button, getPaletteColor } from 'pcln-design-system'

export const FilterTextButton = styled(Button)`
  border: none;
  background: transparent;
  color: ${getPaletteColor('primary.base')};
  padding: 0;
  margin-left: 15px;
  &:hover {
    background: transparent;
    color: ${getPaletteColor('primary.base')};
  }
`
